import React, { useState } from "react";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import ButtonGroup from "../elements/ButtonGroup";
import Button from "../elements/Button";
import Image from "../elements/Image";
import Modal from "../elements/Modal";

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const AboutHero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  };

  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className,
  );

  const innerClasses = classNames(
    "hero-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider",
  );

  return (
    <div className="container-sm">
      <div className="spacer-32">
        <div
          className="hero-figure reveal-from-bottom illustration-element-01"
          data-reveal-value="20px"
          data-reveal-delay="800"
        >
          <a
            data-video="https://drivesvideo.s3.amazonaws.com/Styles+of+Play+v2.mp4"
            href="#0"
            aria-controls="video-modal"
            onClick={openModal}
          >
            <Image
              className="has-shadow"
              src={require("../../assets/images/video-placeholder.jpg")}
              alt="Hero"
              width={896}
              height={504}
            />
          </a>
        </div>
        <Modal
          id="video-modal"
          show={videoModalActive}
          handleClose={closeModal}
          video="https://drivesvideo.s3.amazonaws.com/Styles+of+Play+v2.mp4"
          videoTag="iframe"
        />
      </div>
    </div>
  );
};

AboutHero.propTypes = propTypes;
AboutHero.defaultProps = defaultProps;

export default AboutHero;
